module.exports = {
	NUMBER: 'number',
	DATE: 'date',
	TEXT: 'TEXT',
	BOOLEAN: 'BOOLEAN',
	FUNCTION: 'FUNCTION',
	STATUS: 'STATUS'
}




// WEBPACK FOOTER //
// ./src/utils/TypesConstants.js